import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

type ModulePullRequestsTableExpandedRowsStore = {
  expandedRows: Set<string>;
  toggleRow: (pullRequestId: string) => void;
  reset: () => void;
};

const useModulePullRequestsTableExpandedRowsStore =
  create<ModulePullRequestsTableExpandedRowsStore>()(
    immer((set) => ({
      expandedRows: new Set(),

      toggleRow: (pullRequestId) =>
        set((state) => {
          if (state.expandedRows.has(pullRequestId)) {
            state.expandedRows.delete(pullRequestId);
          } else {
            state.expandedRows.add(pullRequestId);
          }
        }),

      reset: () =>
        set((state) => {
          state.expandedRows.clear();
        }),
    }))
  );

export default useModulePullRequestsTableExpandedRowsStore;
